export const ERROR_EVENT_TYPES = new Set(["event", "error"]);
export const TRACE_EVENT_TYPES = new Set(["transaction"]);
export const PROFILE_EVENT_TYPES = new Set(["profile"]);
export const LOG_EVENT_TYPES = new Set(["log"]);
export const SUPPORTED_EVENT_TYPES = new Set([
    ...ERROR_EVENT_TYPES,
    ...TRACE_EVENT_TYPES,
    ...PROFILE_EVENT_TYPES,
    ...LOG_EVENT_TYPES,
]);
export function isErrorEvent(event) {
    return (!event.type || ERROR_EVENT_TYPES.has(event.type)) && Boolean(event.exception);
}
export function isProfileEvent(event) {
    return !!event.type && PROFILE_EVENT_TYPES.has(event.type) && event.version === "1";
}
export function isTraceEvent(event) {
    return !!event.type && TRACE_EVENT_TYPES.has(event.type);
}
export function isLogEvent(event) {
    return !!event.type && LOG_EVENT_TYPES.has(event.type);
}
